<template>
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <el-input
        v-model="cargoDoc.consigneeCode"
        :disabled="disabled"
        style="flex:1"
      />
      <cargo-advance-select
        :disabled="disabled"
        :select-type="selectTypeNames.basic_data_Company"
        :method-params="{ consignee: true, active: true }"
        filterable
        :default-value="cargoDoc.consigneeId||''"
        style="flex:1"
        @parentCallBack="consigneeAutoCompleteChange"
      />
      <el-button
        no="reset"
        type="primary"
        :disabled="disabled"
        style="margin-left: 5px"
        @click="onClear"
      >{{ $t('SeaExport.Reset') }}
      </el-button>
    </div>
    <cargo-input
      v-for="i in 7"
      :key="i"
      v-model="cargoDoc['consigneeLine'+i]"
      :use-read-only="true"
      :disabled="disabled"
      :auto-uppercase="autoUppercase"
      :filter-chars="false"
      style="margin-top: 5px"
      @change="onChange('consigneeLine'+i)"
      @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,autoUppercase,{autoHalfWord:true,autoUppercase:autoUppercase})"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="disabled"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="!disabled"
          no="advanceTextDialogConfirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { Company } from '@/class/model/mdm/Company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'

export default {
  name: 'SeCargoDocConsignee',
  components: { cargoInput, cargoAdvanceSelect, cargoRichTextarea },
  props: {
    cargoDoc: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    autoUppercase: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      }
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.cargoDoc[key] }])
    },
    async consigneeAutoCompleteChange(data) {
      const form = this.cargoDoc
      form.consigneeId = data.value || 0
      if (data.value) {
        const company = new Company(data)
        await company.getMainfestAddress()
        CargoDocUtil.applyConsigneeManifestAddress(form, data)
      } else {
        CargoDocUtil.onClear(form, 2)
      }
      this.changeAllItem(form)
    },
    onClear() {
      CargoDocUtil.onClear(this.cargoDoc, 2)
      this.changeAllItem(this.cargoDoc, ['consigneeId'])
    },
    changeAllItem(form, ignoreKeys = []) {
      const items = []
      if (!ignoreKeys.includes('consigneeCode')) {
        items.push({ key: 'consigneeCode', value: form.consigneeCode })
      }
      if (!ignoreKeys.includes('consigneeId')) {
        items.push({ key: 'consigneeId', value: form.consigneeId })
      }
      for (let i = 1; i <= 7; i++) {
        if (!ignoreKeys.includes(`consigneeLine${i}`)) {
          items.push({ key: `consigneeLine${i}`, value: form[`consigneeLine${i}`] })
        }
      }
      this.$emit('childrenChange', items)
    },
    // 高级文本弹框相关方法
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      // 关闭弹框时的清理工作
    },
    // 合并收货人地址行
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.cargoDoc['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.cargoDoc['consigneeLine7'] || '')
      return result.trimEnd()
    },
    // 分割收货人地址行
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.cargoDoc['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.cargoDoc['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.cargoDoc['consigneeLine' + i] = ''
      }

      // 通知父组件数据变更
      this.changeAllItem(this.cargoDoc)
    }
  }
}
</script>
